<template>
  <div class="flex items-center gap-2" :class="clickableClass" @click="onClick">
    <img v-if="value && isActive" src="@/assets/icons/checked_color_on.svg" class="check" />
    <img v-else-if="value" src="@/assets/icons/checked_on.svg" class="check" />
    <img v-else src="@/assets/icons/checked_off.svg" class="check" />
    <p v-if="!!label" class="flex-1" :class="{'whitespace-no-wrap': whiteSpaceNowrap}">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: "PrintCheckbox",
  props: {
    label: String,
    value: Boolean,
    color: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    whiteSpaceNowrap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive() {
      return this.color || (!this.disabled && this.clickable);
    },
    clickableClass() {
      if (!this.clickable) return '';
      return this.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer';
    },
  },
  methods: {
    onClick() {
      if (!this.clickable || this.disabled) return;
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
